import { Card } from 'antd';
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartFilters from './ChartFilters';



ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const graphColor = '#fc4c02';



const DashboardGraphs = ({
  meetingsPerMonth,
  title,
  onFilterChange,
}) => {
  const meetingsLineData = {
  labels: meetingsPerMonth.map((d: any) => d.label),
  datasets: [
    {
      label: title.includes('hrs') ? 'Hours' : 'Visits',
      data: meetingsPerMonth.map((d: any) => d.value),
      borderColor: graphColor,
      backgroundColor: 'rgba(234,95,33,0.1)',
      tension: 0.4,
      fill: true,
    },
  ],
};


  const meetingsChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true, position: 'top' as const },
      title: { display: false },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Month',
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Visits',
        },
      },
    },
  };

  return (
    <Card
  className="w-full"
  title={
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <div className="text-base font-semibold">
        {title}
      </div>

      <div className="flex flex-wrap justify-start sm:justify-end">
        <ChartFilters
          showDateFilter
          showPeriodFilter
          onChange={onFilterChange}
        />
      </div>

    </div>
  }
>
  <div className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px]">
    <Line data={meetingsLineData} options={meetingsChartOptions} />
  </div>
</Card>


  );
};

export default DashboardGraphs;
